import script from "./CourseItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CourseItem.vue?vue&type=script&lang=ts&setup=true"

import "./CourseItem.vue?vue&type=style&index=0&id=65193269&lang=scss&scoped=true"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65193269"]])

export default __exports__